import { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.bearing-intelligence.com';

const SOURCE_TYPE_LABELS = {
  official_statement: 'Official Statement',
  wire_service:       'Wire Service',
  think_tank:         'Think Tank',
  satellite_imagery:  'Satellite Imagery',
  regional_press:     'Regional Press',
  academic:           'Academic',
  social_media:       'Social Media',
};

const ICS_COLORS = {
  A:'#44aa66', B:'#81c784', C:'#c4a563', D:'#ff9933', E:'#ff5555', F:'#8a9bbf'
};

const ICS_FULL = {
  A1:'Completely reliable + Confirmed',
  A2:'Completely reliable + Probably true',
  B1:'Usually reliable + Confirmed',
  B2:'Usually reliable + Probably true',
  B3:'Usually reliable + Possibly true',
  C2:'Fairly reliable + Probably true',
  C3:'Fairly reliable + Possibly true',
  D3:'Not usually reliable + Possibly true',
  D4:'Not usually reliable + Doubtfully true',
  E4:'Unreliable + Doubtfully true',
  E5:'Unreliable + Improbable',
  F6:'Unknown reliability + Cannot be judged',
};

export function SourceListInline({ briefingId, devIdx, headline }) {
  const [sources,   setSources]   = useState([]);
  const [loading,   setLoading]   = useState(true);
  const [expanded,  setExpanded]  = useState(false);

  useEffect(() => {
    if (!briefingId || devIdx === undefined) return;
    fetch(`${API_URL}/api/sources/${briefingId}/${devIdx}`)
      .then(r => r.json())
      .then(d => setSources(d.sources || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [briefingId, devIdx]);

  if (loading || sources.length === 0) return null;

  return (
    <div style={{ marginTop:8 }}>
      <button onClick={() => setExpanded(e=>!e)} style={{
        background:'none', border:'none', cursor:'pointer', padding:0,
        color:'#c4a563', fontSize:11, display:'flex', alignItems:'center', gap:5
      }}>
        <span style={{ fontSize:12 }}>📎</span>
        <span style={{ textDecoration:'underline', textDecorationStyle:'dotted' }}>
          {sources.length} source{sources.length>1?'s':''} · More info
        </span>
        <span style={{ opacity:0.5 }}>{expanded?'▲':'▼'}</span>
      </button>

      {expanded && (
        <div style={{ marginTop:8, padding:'10px 12px',
          backgroundColor:'rgba(255,255,255,0.02)',
          border:'1px solid rgba(196,165,99,0.1)',
          borderRadius:6 }}>

          {/* Disclaimer */}
          <div style={{ padding:'6px 8px', backgroundColor:'rgba(255,165,0,0.08)',
            border:'1px solid rgba(255,165,0,0.2)', borderRadius:4,
            marginBottom:10, fontSize:10, color:'#aa8833', lineHeight:1.5 }}>
            ⚠️ Source links are AI-suggested starting points based on likely reporting outlets.
            URLs may not be exact. Always verify independently. Bearing Intelligence does not
            endorse external content and assumes no liability for third-party sources.
          </div>

          {sources.map((src, i) => {
            const icsColor = ICS_COLORS[src.reliability] || '#666';
            const icsDesc = ICS_FULL[src.ics_code] || `${src.reliability||'?'}${src.credibility||'?'}`;
            return (
              <div key={i} style={{ marginBottom: i<sources.length-1 ? 10 : 0,
                paddingBottom: i<sources.length-1 ? 10 : 0,
                borderBottom: i<sources.length-1 ? '1px solid rgba(255,255,255,0.05)' : 'none' }}>
                <div style={{ display:'flex', gap:8, alignItems:'flex-start' }}>
                  {/* Rank */}
                  <span style={{ color:'#444', fontSize:11, fontWeight:'bold',
                    flexShrink:0, minWidth:16 }}>{src.rank}.</span>
                  <div style={{ flex:1 }}>
                    {/* Title + ICS badge */}
                    <div style={{ display:'flex', gap:6, alignItems:'flex-start',
                      flexWrap:'wrap', marginBottom:3 }}>
                      {src.url ? (
                        <a href={src.url} target="_blank" rel="noopener noreferrer"
                          style={{ color:'#c4a563', fontSize:12, fontWeight:'bold',
                            textDecoration:'none', lineHeight:1.4 }}>
                          {src.title} ↗
                        </a>
                      ) : (
                        <span style={{ color:'#c4a563', fontSize:12, fontWeight:'bold' }}>
                          {src.title}
                        </span>
                      )}
                      {src.ics_code && (
                        <span style={{ padding:'1px 6px', borderRadius:3, fontSize:10,
                          fontWeight:'bold', flexShrink:0,
                          backgroundColor: icsColor+'22', color:icsColor,
                          border:`1px solid ${icsColor}55` }}
                          title={icsDesc}>
                          {src.ics_code}
                        </span>
                      )}
                      {src.source_type && (
                        <span style={{ color:'#444', fontSize:10 }}>
                          {SOURCE_TYPE_LABELS[src.source_type] || src.source_type}
                        </span>
                      )}
                    </div>
                    {src.summary && (
                      <p style={{ color:'#666', fontSize:11, lineHeight:1.5, margin:0 }}>
                        {src.summary}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
